// Action types
export const SEARCH_SET_TYPE_SORTING = 'SEARCH:SET_TYPE_SORTING';

// Search type constants
export const SEARCH_TYPES = {
    COLLEGES: 'colleges',
    HIGH_SCHOOLS: 'highSchools',
};
